<template>
  <div class="hero">
    <img class="hero__image" src="@images/heroImage.png" alt="">
    <div class="container">
      <div class="hero__inner">
        <p class="hero__subtext">Welcome to <span>LUNATRIX LTD</span></p>
        <h1 class="hero__title">driving innovation step By Step</h1>
        <button class="hero__button" @click="scrollTo('contact', 'home')">
          Contact Us
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.5 7.5L20 12M20 12L15.5 16.5M20 12H4" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import {scroll} from "@/core/helpers/scrollTo.js";
import {useRoute, useRouter} from "vue-router";

const router = useRouter()
const route = useRoute()

const scrollTo = (id, routeName) => {
  if (route.name === routeName) {
    scroll(id);
  } else {
    router.push({
      name: 'home'
    }).then(scroll(id));
  }
}
</script>

<style lang="scss" scoped>
.hero {
  position: relative;
  background-image: url(@images/heroBg.png);
  -webkit-background-size: cover;
  background-size: cover;
  background-repeat: no-repeat;

  &__image {
    width: 90%;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
  }

  &__wrapper {
    width: 90%;
    margin-inline: auto;
    background-color: #C3DBF3;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
    border-radius: 0 0 48px 48px;
    background-image: url(@images/heroImage.png);
    -webkit-background-size: cover;
    background-size: cover;
    background-repeat: no-repeat;
  }

  &__inner {
    padding-block: 225px;
    position: relative;
    z-index: 1;
  }

  &__subtext {
    color: #272343;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 1.68px;
    text-transform: uppercase;

    & span {
      font-weight: 600;
    }
  }

  &__title {
    width: 600px;
    color: #272343;
    font-size: 52px;
    font-weight: 900;
    line-height: 110%;
    text-transform: capitalize;
  }

  &__button {
    cursor: pointer;
    margin-top: 50px;
    border-radius: 8px;
    background-color: #029FAE;
    display: flex;
    align-items: center;
    gap: 30px;
    padding: 10px 20px 10px 30px;
    transition: 0.2s;

    color: $white;
    font-size: 16px;
    font-weight: 600;
    line-height: 110%;
    text-transform: capitalize;

    @include hover {
      background-color: #007581;
    }
  }
}

@media (max-width: 1400px) {
  .hero {
    &__inner {
      padding-block: 100px 250px;
    }

    &__title {
      width: 442px;
      font-size: 48px;
    }
  }
}

@media (max-width: 1000px) {
  .hero {
    &__image {
      width: 95%;
      height: 450px;
      object-fit: cover;
      border-radius: 0 0 48px 48px;
    }

    &__inner {
      padding-block: 50px 300px;
    }
  }
}
</style>